(function(root){
 // UI only. Functions independently authenticate the buyer on every invocation.
 function create({fetchScope,initial=false}){
  let active=initial;
  return {
   get active(){return active;},
   async refresh(){try{const next=await fetchScope();if(typeof next!=='boolean')throw new Error('Invalid scope');active=next;return active;}catch(error){active=false;throw error;}},
   removals(cart){return (cart.items||[]).filter(i=>active
    ? i.properties?._cl_reward_gift==='true'&&i.properties?._cl_bundle_gift==null
    : i.properties?._cl_bundle_gift!=null).map(i=>i.key);},
   properties(existing,tier){const props={...existing};delete props._cl_bundle_gift;if(active)props._cl_bundle_gift=String(tier);return props;}
  };
 }
 if(typeof module==='object'&&module.exports)module.exports={create};
 if(typeof document==='undefined')return;
 const node=document.querySelector('[data-cl-test-scope]');
 const nativeFetch=root.fetch.bind(root);
 root.CraftlabelTestScope=create({initial:node?.dataset.active==='true',fetchScope:async()=>{
  const url=new URL((root.Shopify?.routes?.root||'/'),root.location.origin);
  url.searchParams.set('section_id','craftlabel-test-scope');url.searchParams.set('_scope_refresh',String(Date.now()));
  const response=await nativeFetch(url.toString(),{credentials:'same-origin',cache:'no-store',headers:{Accept:'text/html'}});
  if(!response.ok)throw new Error('Test hesabı doğrulanamadı. Sayfayı yenileyin.');
  const element=new DOMParser().parseFromString(await response.text(),'text/html').querySelector('[data-cl-test-scope]');
  if(!element||!['true','false'].includes(element.dataset.active))throw new Error('Test hesabı doğrulanamadı. Sayfayı yenileyin.');
  return element.dataset.active==='true';
 }});
 root.addEventListener('pageshow',()=>root.CraftlabelCart?.refresh({silent:true}));
 root.addEventListener('focus',()=>root.CraftlabelCart?.refresh({silent:true}));
})(typeof window==='object'?window:globalThis);
